<template>
  <ul v-show="highlightList.length" class="highlight-box">
    <li
      v-for="item in highlightList"
      :key="item.id"
      @click="goLocation(item)"
      :class="activeMark == item.id ? 'active' : ''"
    >
      <div class="top-box">
        <div class="top-title">{{ item.activeChapterName }}</div>
        <div class="top-button">
          <a class="add-mind-btn" @click.stop="mindMapAdd(item)">脑图</a>
          <!-- <el-button @click.stop="mindMapAdd(item)" size="mini">
            {{ item.isMindMap ? '移除脑图' : '引入脑图' }}
          </el-button> -->
        </div>
      </div>
      <p class="noteTxt ellipsis-2">{{ item.content }}</p>
      <div class="bot-box">
        <span class="update-time">{{ item.updateTime }}</span>
        <div class="operate-box">
          <a class="delete-btn" @click.stop="delRecordLi(item)">
            <span><i class="icon el-icon-delete"></i></span>
          </a>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "highlight",
  props: {
    highlightList: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      activeMark: ''
    }
  },
  methods: {
    // 切换章节以及表格的tab
    chapterChange(item) {
      return new Promise((resolve,reject) => {
        this.$emit('chapterChange', item.activeChapter, true);
        
        if((item.startNodeId + '').indexOf('table') > -1) {
          this.$nextTick(() => {
            setTimeout(()=> {
              let idBefore = item.startNodeId.split('table')[0];
              let tableTabKey = idBefore.substring(0, idBefore.length-1);
              let lastIndex = tableTabKey.lastIndexOf('.');
              let tableKey = tableTabKey.substring(0, lastIndex)
              this.$emit('tableTabChange', tableKey, tableTabKey);
              resolve();
            }, 20);
          });
        }else{
          resolve();
        }
      })
    },
    // 点击高亮列表，跳转到对应高亮处
    async goLocation(item) {
      let data_mark = item.id;
      this.activeMark = data_mark;
      await this.chapterChange(item)
      this.toElement(data_mark)
    },
    toElement(id) {
      const element = document.getElementById(id);
      if(!element) {
        setTimeout(() => {
          this.toElement(id)
        }, 100)
        return false
      }
      this.$nextTick(() => {
        setTimeout(()=> {
          // 导航滚动定位
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth', // 平滑滚动
              block: "center", // 垂直居中对齐
            });
          }
        }, 100);
      })
    },
    mindMapAdd(item) {
      this.$emit('mindMapAdd', item)
    },
    delRecordLi(item) {
      this.$emit('delRecordLi', item.id)
    },
    // 关闭弹窗
    closeDrawer() {
      this.$emit('closeDrawer', 'highlight')
    },
  }
}
</script>

<style lang="scss" scoped>
.highlight-box{
  li {
    padding: 20rem 39rem 22rem;
    border-bottom: 1rem solid #f1f1f1;
    .top-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15rem;

      .top-title{
        font-size: 24rem;
        color: #999;
      }

      .top-button{
        .add-mind-btn{
          display: block;
          height: 50rem;
          line-height: 50rem;
          font-size: 26rem;
          color: #FFFFFF;
          text-align: center;
          border-radius: 6rem;
          background: #18C49E;
          cursor: pointer;
          user-select: none;
          overflow: hidden;
          padding: 0 15rem;
        }
      }
    }
    .noteTxt {
      font-size: 28rem;
      line-height: 38rem;
      margin-bottom: 18rem;
      color: #313131;
      height: auto;
      max-height: 114rem;
      -webkit-line-clamp: 3;
    }
    .bot-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .update-time {
        font-size: 24rem;
        line-height: 50rem;
        color: #999999;
      }
      .operate-box {
        display: flex;
        a {
          margin-left: 10rem;
          width: 50rem;
          height: 50rem;
          font-size: 28rem;
          color: #2f4058;
          text-align: center;
          border-radius: 10rem;
          background: #fff;
          cursor: pointer;
          user-select: none;
          overflow: hidden;
          text-align: center;
          line-height: 50rem;
          i {
            font-size: 28rem;
            color: #2f4058;
            display: inline-block;
          }
        }
      }
    }
  }
  li:last-child {
    border-bottom: none;
    margin-bottom: 20rem;
  }
  li.active {
    background: #F7F7F7 url("~@/assets/images/common/location.png") left top no-repeat;
    background-size: 48rem 48rem;
  }
}
</style>